import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import SiteGate from "@/components/SiteGate";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Home from "@/pages/Home";
import AIAssistant from "@/pages/AIAssistant";
import Clients from "@/pages/Clients";
import Leads from "@/pages/Leads";
import Tasks from "@/pages/Tasks";
import WeeklyBrief from "@/pages/WeeklyBrief";
import RetentionRadar from "@/pages/RetentionRadar";
import Business from "@/pages/Business";
import CRM from "@/pages/CRM";
import Marketing from "@/pages/Marketing";
import ContentStudio from "@/pages/ContentStudio";
import Publish from "@/pages/Publish";
import Notifications from "@/pages/Notifications";
import Social from "@/pages/Social";
import Market from "@/pages/Market";
import FundResearch from "@/pages/FundResearch";
import Regulatory from "@/pages/Regulatory";
import Learn from "@/pages/Learn";
import Community from "@/pages/Community";
import InvestorAwareness from "@/pages/InvestorAwareness";
import Messages from "@/pages/Messages";
import Notebook from "@/pages/Notebook";
import AMCs from "@/pages/AMCs";
import Tools from "@/pages/Tools";
import Consultants from "@/pages/Consultants";
import Studios from "@/pages/Studios";
import Wallet from "@/pages/Wallet";
import Profile from "@/pages/Profile";
import MyMFDx from "@/pages/MyMFDx";
import Admin from "@/pages/Admin";
import WebsiteBuilder from "@/pages/WebsiteBuilder";
import Appointments from "@/pages/Appointments";
import Microsite from "@/pages/Microsite";
import BookPublic from "@/pages/BookPublic";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="h-screen grid place-items-center text-gray-400 font-head">Loading MFDX…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded && user.role !== "admin") return <Navigate to="/onboarding" replace />;
  return children;
}

function App() {
  return (
    <SiteGate>
      <AuthProvider>
        <BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/signup" element={<Auth mode="signup" />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/site/:slug" element={<Microsite />} />
          <Route path="/book/:slug" element={<BookPublic />} />
          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Home />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="ai" element={<AIAssistant />} />
            <Route path="clients" element={<Clients />} />
            <Route path="leads" element={<Leads />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="weekly" element={<WeeklyBrief />} />
            <Route path="retention" element={<RetentionRadar />} />
            <Route path="business" element={<Business />} />
            <Route path="crm" element={<CRM />} />
            <Route path="marketing" element={<Marketing />} />
            <Route path="content" element={<ContentStudio />} />
            <Route path="publish" element={<Publish />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="social" element={<Social />} />
            <Route path="market" element={<Market />} />
            <Route path="funds" element={<FundResearch />} />
            <Route path="regulatory" element={<Regulatory />} />
            <Route path="learn" element={<Learn />} />
            <Route path="community" element={<Community />} />
            <Route path="investor-awareness" element={<InvestorAwareness />} />
            <Route path="messages" element={<Messages />} />
            <Route path="notebook" element={<Notebook />} />
            <Route path="amcs" element={<AMCs />} />
            <Route path="tools" element={<Tools />} />
            <Route path="consultants" element={<Consultants />} />
            <Route path="studios" element={<Studios />} />
            <Route path="website" element={<WebsiteBuilder />} />
            <Route path="appointments" element={<Appointments />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="profile" element={<Profile />} />
            <Route path="my-mfdx" element={<MyMFDx />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </SiteGate>
  );
}
export default App;
